// import React from 'react';
// import './TrustedSources.css';

// const TrustedSources = () => {
//   const sources = [
//     { 
//       name: "Transport for London", 
//       description: "Transport data",
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//           <path d="M12 2c2.131 0 4 1.73 4 3.702 0 2.05-1.714 4.941-4 8.561-2.286-3.62-4-6.511-4-8.561C8 3.73 9.869 2 12 2zm0-2C8.852 0 6 2.553 6 5.702 6 9.533 9.246 14.175 12 18c2.754-3.825 6-8.467 6-12.298C18 2.553 15.149 0 12 0z"/>
//           <path d="M12 12c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"/>
//         </svg>
//       )
//     },
//     { 
//       name: "Ofsted", 
//       description: "School ratings",
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//           <path d="M21 3h-4V1h-2v2H9V1H7v2H3v18h18V3zm-2 16H5V8h14v11z"/>
//           <path d="M7 10h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
//         </svg>
//       )
//     },
//     { 
//       name: "NHS", 
//       description: "Healthcare services",
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm0-8h-2V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
//         </svg>
//       )
//     },
//     // { 
//     //   name: "Ordnance Survey", 
//     //   description: "Geographic data",
//     //   icon: (
//     //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//     //       <path d="M12 2L1 21h22L12 2zm0 4.5l7.09 12.5H4.91L12 6.5z"/>
//     //       <path d="M12 16.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"/>
//     //     </svg>
//     //   )
//     // },
//     { 
//       name: "Google API", 
//       description: "Global data services",
//       icon: (
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//           <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"/>
//           <path d="M11 11H7v2h4v4h2v-4h4v-2h-4V7h-2z"/>
//         </svg>
//       )
//     }
//   ];

//   return (
//     <section className="trusted-sources">
//       <div className="sources-container">
//         <div className="sources-header">
//           <h2 className="section-tit</svg>le">Trusted Data Sources</h2>
//           <p className="section-description">
//             We aggregate data from multiple authoritative sources to ensure accuracy and completeness.
//           </p>
//         </div>
        
//         <div className="sources-grid">
//           {sources.map((source, index) => (
//             <div className="source-card" key={index}>
//               <div className="source-icon">
//                 {source.icon}
//               </div>
//               <h3>{source.name}</h3>
//               <p>{source.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TrustedSources;

















import React from 'react';
import './TrustedSources.css';

const TrustedSources = () => {
  const sources = [
    { 
      name: "Transport for London", 
      description: "Transport data",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2c2.131 0 4 1.73 4 3.702 0 2.05-1.714 4.941-4 8.561-2.286-3.62-4-6.511-4-8.561C8 3.73 9.869 2 12 2zm0-2C8.852 0 6 2.553 6 5.702 6 9.533 9.246 14.175 12 18c2.754-3.825 6-8.467 6-12.298C18 2.553 15.149 0 12 0z"/>
          <path d="M12 12c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"/>
        </svg>
      )
    },
    { 
      name: "Ofsted", 
      description: "School ratings",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 3h-4V1h-2v2H9V1H7v2H3v18h18V3zm-2 16H5V8h14v11z"/>
          <path d="M7 10h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
        </svg>
      )
    },
    { 
      name: "NHS", 
      description: "Healthcare services",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm0-8h-2V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
        </svg>
      )
    },
    { 
      name: "Google API", 
      description: "Global data services",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"/>
          <path d="M11 11H7v2h4v4h2v-4h4v-2h-4V7h-2z"/>
        </svg>
      )
    }
  ];

  return (
    <section className="trusted-sources">
      <div className="sources-container">
        <div className="sources-header">
          {/* Fixed typo in className */}
          <h2 className="section-title">Trusted Data Sources</h2>
          <p className="section-description">
            We aggregate data from multiple authoritative sources to ensure accuracy and completeness.
          </p>
        </div>
        
        <div className="sources-grid">
          {sources.map((source, index) => (
            <div className="source-card" key={index}>
              <div className="source-icon">
                {source.icon}
              </div>
              <h3>{source.name}</h3>
              <p>{source.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedSources;